var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "previewScreenshotRootBox",
          attrs: { id: "previewScreenshot" }
        },
        [
          _c(
            "div",
            { staticClass: "previewScreenshotContentBox" },
            [
              _c(
                "div",
                {
                  staticClass: "rect",
                  style:
                    _vm.time > 5 && _vm.time <= 10
                      ? {
                          left: "30px",
                          top: "65px",
                          height: "258px",
                          width: "318px"
                        }
                      : _vm.time > 10 && _vm.time <= 15
                      ? { left: "450px", top: "448px", width: "60px" }
                      : null
                },
                [
                  _c("div", { staticClass: "numTime" }, [
                    _vm._v(_vm._s(_vm.time / 5))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("el-image", {
                staticStyle: { width: "600px", height: "500px" },
                attrs: { src: "static/images/IT/screenshot_tip.png" }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-circle-close",
                attrs: { title: "关闭" },
                on: { click: _vm.close }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "tip" }, [_vm._v(_vm._s(_vm.tip))])
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3507f34a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3507f34a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/teachingDetail/list/classroom/previewScreenshot.vue
// module id = null
// module chunks = 